import React from 'react';
import {useField} from 'formik';
import className from 'classnames';
import FieldSelect from '../../../../common/components/FieldSelect';
import FieldInput from '../../../../common/components/FieldInput';
import {customerStatus, customerTypes, genderOptions} from '../../../../common/constants/options';
import styles from './AddEditCustomerForm.module.scss';

const FormCustomerTypePerson = () => {
  return (
    <>
      <div className={styles.row}>
        <FieldInput
          fieldId={'firstName'}
          label={(
            <div className="d-inline-block font-weight-bolder text-dark-75">
              <span className={'text-danger'}>*</span>
              שם פרטי
            </div>
          )}
          containerCustomStyles={styles.col}
        />
        <FieldInput
          fieldId={'lastName'}
          label={(
            <>
              <span className={styles.mandatory}>*</span>
              שם משפחה
            </>
          )}
          containerCustomStyles={styles.col}
        />
      </div>
      <div className={styles.row}>
        <FieldSelect
          fieldId={'gender'}
          options={genderOptions}
          label={'מגדר'}
          placeholder={'בחר'}
          containerStyles={styles.col}
        />
        <FieldInput
          fieldId={'idNumber'}
          label={'מספר זהות'}
          containerCustomStyles={styles.col}
        />
      </div>
    </>
  );
};

const FormCustomerTypesCompany = () => {
  return (
    <>
      <div className={styles.row}>
        <FieldInput
          fieldId={'firstName'}
          label={(
            <>
              <span className={styles.mandatory}>*</span>
              שם
            </>
          )}
          containerCustomStyles={styles.col}
        />
      </div>
      <div className={styles.row}>
        <FieldInput
          fieldId={'idNumber'}
          label={(
            <>
              <span className={styles.mandatory}>*</span>
              מספר זיהוי
            </>
          )}
          containerCustomStyles={styles.col}
        />
      </div>
    </>
  );
};

const FormCustomerTypeGroup = () => {
  return (
    <>
      <div className={styles.row}>
        <FieldInput
          fieldId={'firstName'}
          label={(
            <>
              <span className={styles.mandatory}>*</span>
              שם קבוצה
            </>
          )}
          containerCustomStyles={styles.col}
        />
        <FieldInput
          fieldId={'lastName'}
          label={(
            <>
              <span className={styles.mandatory}>*</span>
              שם מחלקה/חברת בת
            </>
          )}
          containerCustomStyles={styles.col}
        />
      </div>
      <div className={styles.row}>
        <FieldInput
          fieldId={'idNumber'}
          label={(
            <>
              <span className={styles.mandatory}>*</span>
              מספר זיהוי
            </>
          )}
          containerCustomStyles={styles.col}
        />
      </div>
    </>
  );
};

export const AddEditCustomerForm = () => {
  const [customerTypeField] = useField('customerType');

  const renderFormByCustomerType = (customerType) => {
    switch (customerType) {
      case 1:
      case 2:
      case 3:
        return <FormCustomerTypesCompany/>;
      case 4:
        return <FormCustomerTypePerson/>;
      case 5:
        return <FormCustomerTypeGroup/>;
      default:
        return null;
    }
  };

  return (
    <div className={styles.addCustomerFormContainer}>
      <div className={styles.row}>
        <FieldSelect
          fieldId="customerType"
          options={customerTypes}
          label={'סוג לקוח'}
          containerStyles={styles.col}
        />
      </div>
      {renderFormByCustomerType(customerTypeField.value.value)}
      <div className={styles.row}>
        <FieldInput
          fieldId={'phone'}
          label={(
            <div className="d-inline-block font-weight-bolder text-dark-75">
              טלפון
            </div>
          )}
          containerCustomStyles={styles.col}
        />
        <FieldInput
          fieldId={'email'}
          label={(
            <div className="d-inline-block font-weight-bolder text-dark-75">
              דוא"ל
            </div>
          )}
          ltrDirection={true}
          containerCustomStyles={styles.col}
        />
      </div>
      <div className={styles.row}>
        <FieldInput
          fieldId={'address'}
          label={(
            <div className="d-inline-block font-weight-bolder text-dark-75">
              כתובת הלקוח (לחשבונית)
            </div>
          )}
          containerCustomStyles={className(styles.col, styles.fullSize)}
        />
      </div>
      <div className={styles.row}>
        <FieldSelect
          fieldId={'status'}
          options={customerStatus}
          label={(
            <>
              <span className={styles.mandatory}>*</span>
              סטטוס
            </>
          )}
          containerStyles={styles.col}
        />
      </div>
    </div>
  );
};